import { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Button, Input } from '@touche-lts/panel-ui/dist'
import { useRootStore } from 'mobx-stores/store-provider'
import { SHOPIFY_PURCHASE_PIN } from 'utilities'
import styles from './shopify-pin-dialog.module.scss'

const ShopifyPinDialogComponent = () => {
  const {
    generalStore: {
      shopifyPinDialog,
      confirmShopifyPinDialog,
      cancelShopifyPinDialog,
    },
  } = useRootStore()

  const [pin, setPin] = useState('')
  const [error, setError] = useState('')

  const isPinValid = pin === SHOPIFY_PURCHASE_PIN

  useEffect(() => {
    if (!shopifyPinDialog.isOpen) {
      setPin('')
      setError('')
    }
  }, [shopifyPinDialog.isOpen])

  if (!shopifyPinDialog.isOpen) return null

  const handlePinChange = (value: string): void => {
    setPin(value)
    if (value && value !== SHOPIFY_PURCHASE_PIN) {
      setError('Invalid PIN')
    } else {
      setError('')
    }
  }

  return (
    <div className={styles.overlay}>
      <div className={styles.dialog} role="dialog" aria-modal="true">
        <h3 className={styles.title}>Confirm action</h3>
        <p className={styles.message}>{shopifyPinDialog.message}</p>
        <div className={styles.pinField}>
          <Input
            colorPreset="dark"
            type="text"
            placeholder="pin"
            value={pin}
            onChange={handlePinChange}
          />
          {error && <span className={styles.error}>{error}</span>}
        </div>
        <div className={styles.actions}>
          <Button
            preset="secondary"
            colorPreset="dark"
            onClick={cancelShopifyPinDialog}
          >
            Cancel
          </Button>
          <Button
            preset="primary"
            colorPreset="dark"
            disabled={!isPinValid}
            onClick={confirmShopifyPinDialog}
          >
            Submit
          </Button>
        </div>
      </div>
    </div>
  )
}

const ShopifyPinDialog = observer(ShopifyPinDialogComponent)
export { ShopifyPinDialog }
